import { render, staticRenderFns } from "./CtsSlider.vue?vue&type=template&id=d6a561a8&scoped=true"
import script from "./CtsSlider.vue?vue&type=script&lang=js"
export * from "./CtsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a561a8",
  null
  
)

export default component.exports